import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'

export class ChartResource extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      report: [],
      loading: true,
      date: curDate,
      companyId: parseInt(this.props.match.params.companyId) || 1
    };
  }

  componentDidMount() {
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  prevMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() - 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  nextMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() + 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  renderReportTable() {
    var date = this.state.date;
    return (
      <div>

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th width="16px" onClick={() => this.prevMonth()}>&lt;</th>
            <th>Resource</th>
            <th>{date.toLocaleString(undefined, {month: '2-digit', year: 'numeric'})}</th>
            <th width="16px" onClick={() => this.nextMonth()}>&gt;</th>
          </tr>
        </thead>
        <tbody>
          {this.state.report.map(user =>
            <tr key={user.day}>
              <td></td>
              <td>{user.name}</td>
              <td>{user.value}</td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderReportTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="charts" />
        <h4 id="tabelLabel">Monthly income report by resource</h4>
        {contents}
      </div>
    );
  }

  async populateMonthData(companyId, month) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/report/${companyId}/resourcereport?month=${month.toLocaleDateString('en-US')}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, report: data, loading: false}));
  }
}
